import m from "mithril";

// Theme toggle function
const toggleTheme = () => {
  const isDark = document.documentElement.classList.toggle('dark');
  localStorage.setItem('theme', isDark ? 'dark' : 'light');
};

// Reusable Components
const WelcomeSection = {
  view() {
    // Check if dark mode is currently enabled
    const isDarkMode = document.documentElement.classList.contains('dark');
    
    return m("div", { class: "text-center mb-16" }, [
      // Add theme toggle button in the top right corner
      m("div", { class: "flex justify-end mb-4" }, [
        m("button", {
          class: "p-2 rounded-full text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none cursor-pointer",
          onclick: toggleTheme
        }, [
          m("i", { class: isDarkMode ? "ri-sun-line text-xl" : "ri-contrast-2-line text-xl" })
        ])
      ]),
      
      m("div", { class: "max-w-3xl mx-auto" }, [
        m("h1", { class: "text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6" }, "Selamat Datang di VITTA Simpan Pinjam"),
        m("p", { class: "text-xl text-gray-700 dark:text-gray-200 mb-10" }, "Solusi manajemen keuangan unit usaha dan koperasi yang andal dan efisien"),
      ]),

      m("div", { class: "bg-white dark:bg-gray-800 rounded-xl shadow-xl p-8 mb-12" }, [
        m("p", { class: "text-gray-700 dark:text-gray-300 text-lg mb-8" },
          "VITTA Simpan Pinjam adalah platform digital yang dirancang khusus untuk membantu unit usaha dan koperasi dalam mengelola simpanan dan pinjaman anggota dengan mudah dan aman."
        ),

        m("div", { class: "grid grid-cols-1 md:grid-cols-3 gap-8 mb-10" }, [
          m("div", { class: "bg-orange-50 dark:bg-gray-700 p-6 rounded-lg transition-all hover:shadow-md" }, [
            m("div", { class: "bg-orange-100 dark:bg-orange-900 w-12 h-12 rounded-full flex items-center justify-center mb-4" }, [
              m("i", { class: "ri-bank-line text-2xl text-orange-600 dark:text-orange-400" })
            ]),
            m("h3", { class: "text-xl font-semibold text-gray-800 dark:text-white mb-2" }, "Manajemen Simpanan"),
            m("p", { class: "text-gray-600 dark:text-gray-300" }, "Kelola berbagai jenis simpanan anggota dengan fitur pelaporan yang lengkap")
          ]),

          m("div", { class: "bg-orange-50 dark:bg-gray-700 p-6 rounded-lg transition-all hover:shadow-md" }, [
            m("div", { class: "bg-orange-100 dark:bg-orange-900 w-12 h-12 rounded-full flex items-center justify-center mb-4" }, [
              m("i", { class: "ri-money-cny-circle-line text-2xl text-orange-600 dark:text-orange-400" })
            ]),
            m("h3", { class: "text-xl font-semibold text-gray-800 dark:text-white mb-2" }, "Pengelolaan Pinjaman"),
            m("p", { class: "text-gray-600 dark:text-gray-300" }, "Proses pengajuan, persetujuan, dan pelunasan pinjaman secara digital")
          ]),

          m("div", { class: "bg-orange-50 dark:bg-gray-700 p-6 rounded-lg transition-all hover:shadow-md" }, [
            m("div", { class: "bg-orange-100 dark:bg-orange-900 w-12 h-12 rounded-full flex items-center justify-center mb-4" }, [
              m("i", { class: "ri-line-chart-line text-2xl text-orange-600 dark:text-orange-400" })
            ]),
            m("h3", { class: "text-xl font-semibold text-gray-800 dark:text-white mb-2" }, "Laporan Keuangan"),
            m("p", { class: "text-gray-600 dark:text-gray-300" }, "Dapatkan insight keuangan koperasi / unit usaha melalui dashboard dan laporan otomatis")
          ])
        ]),

        m("div", { class: "text-center pt-6" }, [
          m("a", {
            href: "/login",
            class: "inline-block px-8 py-4 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50 transition-colors text-lg shadow-lg hover:shadow-xl",
            oncreate: m.route.link
          }, [
            m("i", { class: "ri-login-box-line mr-2" }),
            "Masuk ke Aplikasi"
          ])
        ])
      ])
    ]);
  }
};

const WhyVittaSection = {
  view() {
    return m("div", { class: "bg-white dark:bg-gray-800 rounded-xl shadow-xl p-8 mb-12" }, [
      m("h2", { class: "text-3xl font-bold text-gray-800 dark:text-white mb-10 text-center" }, "Mengapa Memilih VITTA?"),

      m("div", { class: "grid grid-cols-1 md:grid-cols-2 gap-8" }, [
        m("div", { class: "flex items-start p-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" }, [
          m("div", { class: "bg-green-100 dark:bg-green-900 w-10 h-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" }, [
            m("i", { class: "ri-shield-check-line text-xl text-green-600 dark:text-green-400" })
          ]),
          m("div", [
            m("h3", { class: "text-lg font-semibold text-gray-800 dark:text-white mb-1" }, "Aman & Terpercaya"),
            m("p", { class: "text-gray-600 dark:text-gray-300" }, "Data anggota dilindungi dengan enkripsi dan keamanan tingkat tinggi")
          ])
        ]),

        m("div", { class: "flex items-start p-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" }, [
          m("div", { class: "bg-blue-100 dark:bg-blue-900 w-10 h-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" }, [
            m("i", { class: "ri-flashlight-line text-xl text-blue-600 dark:text-blue-400" })
          ]),
          m("div", [
            m("h3", { class: "text-lg font-semibold text-gray-800 dark:text-white mb-1" }, "Cepat & Efisien"),
            m("p", { class: "text-gray-600 dark:text-gray-300" }, "Proses transaksi dan pelaporan yang cepat dengan antarmuka yang mudah digunakan")
          ])
        ]),

        m("div", { class: "flex items-start p-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" }, [
          m("div", { class: "bg-purple-100 dark:bg-purple-900 w-10 h-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" }, [
            m("i", { class: "ri-smartphone-line text-xl text-purple-600 dark:text-purple-400" })
          ]),
          m("div", [
            m("h3", { class: "text-lg font-semibold text-gray-800 dark:text-white mb-1" }, "Akses Mobile"),
            m("p", { class: "text-gray-600 dark:text-gray-300" }, "Akses aplikasi kapan saja dan di mana saja melalui perangkat mobile")
          ])
        ]),

        m("div", { class: "flex items-start p-4 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" }, [
          m("div", { class: "bg-red-100 dark:bg-red-900 w-10 h-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" }, [
            m("i", { class: "ri-customer-service-line text-xl text-red-600 dark:text-red-400" })
          ]),
          m("div", [
            m("h3", { class: "text-lg font-semibold text-gray-800 dark:text-white mb-1" }, "Dukungan 24/7"),
            m("p", { class: "text-gray-600 dark:text-gray-300" }, "Tim support kami siap membantu kapan saja Anda membutuhkan")
          ])
        ])
      ])
    ]);
  }
};

const TestimonialsSection = {
  view() {
    return m("div", { class: "bg-gradient-to-r from-orange-500 to-orange-600 rounded-xl shadow-xl p-8 mb-12 text-white" }, [
      m("h2", { class: "text-3xl font-bold mb-10 text-center" }, "Apa Kata Pengguna Kami"),
      
      m("div", { class: "grid grid-cols-1 md:grid-cols-3 gap-8" }, [
        m("div", { class: "bg-white dark:bg-gray-800 bg-opacity-20 p-6 rounded-lg" }, [
           m("div", { class: "flex items-center mb-4" }, [
              m("img", { src: "/img/farid-syahroni.jpeg", alt: "Foto FARID SAHRONI", class: "w-16 h-16 rounded-full object-cover flex-shrink-0" }),
           m("div", { class: "ml-4" }, [
                m("h4", { class: "font-bold text-black dark:text-white" }, "FARID SAHRONI"),
                m("p", { class: "text-black dark:text-white" }, "Manajer Koperasi Ekonomi Makmur Asri Sejahtera")
              ])
            ]),
            m("p", { class: "italic text-black dark:text-white" }, "\"Setelah menggunakan aplikasi keuangan Vitta, seluruh pengelolaan keuangan koperasi menjadi jauh lebih terkontrol, baik itu simpanan, kredit, maupun angsuran anggota. Laporan menjadi transparan, akurat, dan dapat dipantau secara real-time. Vitta adalah solusi keuangan yang sangat membantu kemajuan koperasi kami.\"")
         ]),

         m("div", { class: "bg-white dark:bg-gray-800 bg-opacity-20 p-6 rounded-lg" }, [
           m("div", { class: "flex items-center mb-4" }, [
             m("div", { class: "bg-gray-200 dark:bg-gray-600 border-2 border-dashed rounded-xl w-16 h-16" }),
             m("div", { class: "ml-4" }, [
               m("h4", { class: "font-bold text-black dark:text-white" }, "Siti Rahayu"),
               m("p", { class: "text-black dark:text-white" }, "Manajer Unit Simpan Pinjam")
             ])
           ]),
           m("p", { class: "italic text-black dark:text-white" }, "\"Antarmuka yang intuitif membuat staf kami mudah belajar. Fitur pelaporan sangat membantu dalam pengambilan keputusan.\"")
         ]),

         m("div", { class: "bg-white dark:bg-gray-800 bg-opacity-20 p-6 rounded-lg" }, [
           m("div", { class: "flex items-center mb-4" }, [
             m("div", { class: "bg-gray-200 dark:bg-gray-600 border-2 border-dashed rounded-xl w-16 h-16" }),
             m("div", { class: "ml-4" }, [
               m("h4", { class: "font-bold text-black dark:text-white" }, "Ahmad Fauzi"),
               m("p", { class: "text-black dark:text-white" }, "Pengawas Keuangan")
             ])
           ]),
           m("p", { class: "italic text-black dark:text-white" }, "\"Keamanan data dan kemudahan akses membuat VITTA menjadi solusi terbaik untuk manajemen simpan pinjam kami.\"")
         ])
      ])
    ]);
  }
};

const CtaSection = {
  view() {
    return m("div", { class: "text-center py-12" }, [
      m("h2", { class: "text-3xl font-bold text-gray-800 dark:text-white mb-6" }, "Siap Memulai?"),
      m("p", { class: "text-xl text-gray-600 dark:text-gray-300 mb-10 max-w-2xl mx-auto" }, 
        "Bergabunglah dengan ribuan unit usaha yang telah mempercayakan pengelolaan keuangan mereka pada VITTA"),
      
      m("div", [
        m("a", {
          href: "/login",
          class: "inline-block px-10 py-4 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50 transition-colors text-lg shadow-lg hover:shadow-xl mr-4",
          oncreate: m.route.link
        }, "Masuk Sekarang"),
        
        m("a", {
          href: "#",
          class: "inline-block px-10 py-4 bg-white text-orange-600 border border-orange-600 font-semibold rounded-lg hover:bg-orange-50 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50 transition-colors text-lg shadow hover:shadow"
        }, "Jadwalkan Demo")
      ])
    ]);
  }
};

const Landing = {
  view() {
    // For unauthenticated users, show the welcome page
    return m("div", { class: "welcome-container max-w-6xl mx-auto p-6 bg-gray-50 dark:bg-gray-900 min-h-screen" }, [
      m(WelcomeSection),
      m(WhyVittaSection),
      m(TestimonialsSection),
      m(CtaSection)
    ]);
  }
};

export default Landing;
